module.exports = __webpack_public_path__ + "static/media/icon_real_estate.013d5f5c.svg";